/**
 * Pre-launch UX: site banner, sidebar "Create Campaign" disabled, no paid finalize on Create Campaign.
 *
 * 1) If `REACT_APP_LAUNCH_MODE` is set at build time (Render / .env), it wins.
 * 2) If unset (e.g. static build without env), we infer from host: production domain → live.
 *    This avoids "Create Campaign" staying disabled on milan-ai.net when CI didn’t inject the var.
 *
 * CRA still bakes `REACT_APP_*`; hostname runs only in the browser at startup.
 */
const envMode = process.env.REACT_APP_LAUNCH_MODE;
const hasExplicitLaunchEnv =
  envMode != null && String(envMode).trim() !== '';

function inferModeFromHost() {
  if (typeof window === 'undefined') return 'pre_launch';
  const h = window.location.hostname;
  if (h === 'milan-ai.net' || h === 'www.milan-ai.net') return 'live';
  return 'pre_launch';
}

const mode = (hasExplicitLaunchEnv ? String(envMode) : inferModeFromHost())
  .toLowerCase()
  .trim();

export const IS_PRE_LAUNCH = mode !== 'live';
